import { makeActionCreator } from '../../../config/store/utils';
import {
  getHdopTrucks,
  getFatigue,
  getChecks,
  getFrentes,
} from '../../../services/userService';

export const GET_HDOP = 'GET_HDOP';
export const GET_HDOP_ERROR = 'GET_HDOP_ERROR';
export const GET_HDOP_SUCCESS = 'GET_HDOP_SUCCESS';
export const onGetHdop = makeActionCreator(GET_HDOP);
export const onGetHdopError = makeActionCreator(GET_HDOP_ERROR, 'payload');
export const onGetHdopSuccess = makeActionCreator(GET_HDOP_SUCCESS, 'payload');

// Modificar el `onGetAsarcoThunk` para recibir el parámetro `shift`.
export const onGetHdopThunk = date => async dispatch => {
  dispatch(onGetHdop());
  try {
    let endpointParams = {};
    if (date) {
      endpointParams = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    } else {
      const today = new Date();
      const yesterday = new Date(today);
      date = new Date(yesterday.setDate(yesterday.getDate() - 1));
      endpointParams = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    }

    // Llamar a la API y obtener los datos
    const { data } = await getHdopTrucks(endpointParams);

    // Verifica la estructura de los datos recibidos
    let hdop = JSON.parse(data);

    hdop = hdop.map((hdop, index) => ({
      ...hdop,
      id: `${index + 1}`,
    }));

    return dispatch(
      onGetHdopSuccess({
        hdop: hdop,
      })
    );
  } catch (error) {
    console.log(error);
    return dispatch(
      onGetHdopError({
        error: error,
      })
    );
  }
};

export const GET_FATIGUE = 'GET_FATIGUE';
export const GET_FATIGUE_ERROR = 'GET_FATIGUE_ERROR';
export const GET_FATIGUE_SUCCESS = 'GET_FATIGUE_SUCCESS';
export const onGetFatigue = makeActionCreator(GET_FATIGUE);
export const onGetFatigueError = makeActionCreator(
  GET_FATIGUE_ERROR,
  'payload'
);
export const onGetFatigueSuccess = makeActionCreator(
  GET_FATIGUE_SUCCESS,
  'payload'
);

// Modificar el `onGetAsarcoThunk` para recibir el parámetro `shift`.
export const onGetFatigueThunk = (params = {}) => async dispatch => {
  dispatch(onGetFatigue());
  try {
    let endpointParams = {};

    if (params.date && params.current_turn) {
      // Usa los parámetros recibidos
      endpointParams = {
        date: params.date,
        current_turn: params.current_turn,
      };
    } else {
      // Lógica actual para determinar los parámetros
      let today = new Date();
      const hour = today.getHours();
      let turno = '';

      if (hour >= 9 && hour <= 21) {
        turno = 'turno_noche';
      }
      if (hour < 9) {
        turno = 'turno_dia';
        const fecha = new Date();
        const yesterday = new Date(fecha);
        today = new Date(yesterday.setDate(yesterday.getDate() - 1));
      }
      if (hour > 21) {
        turno = 'turno_dia';
      }

      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();

      endpointParams = {
        date: `${year}-${month}-${day}`,
        current_turn: turno,
      };
    }

    // Llamada a la API
    const { data } = await getFatigue(endpointParams);
    let fatigue = JSON.parse(data);

    fatigue = fatigue.map((fatigue, index) => ({
      ...fatigue,
      id: `${index + 1}`,
    }));

    return dispatch(
      onGetFatigueSuccess({
        fatigue,
      })
    );
  } catch (error) {
    console.log(error);
    return dispatch(
      onGetFatigueError({
        error,
      })
    );
  }
};

export const GET_CHECKS = 'GET_CHECKS';
export const GET_CHECKS_ERROR = 'GET_CHECKS_ERROR';
export const GET_CHECKS_SUCCESS = 'GET_CHECKS_SUCCESS';
export const onGetChecks = makeActionCreator(GET_CHECKS);
export const onGetChecksError = makeActionCreator(GET_CHECKS_ERROR, 'payload');
export const onGetChecksSuccess = makeActionCreator(
  GET_CHECKS_SUCCESS,
  'payload'
);

// Modificar el `onGetAsarcoThunk` para recibir el parámetro `shift`.
export const onGetChecksThunk = (params = {}) => async dispatch => {
  dispatch(onGetChecks());
  try {
    let endpointParams = {};

    if (Object.keys(params).length > 0) {
      console.log('entra al if');

      endpointParams = {
        ...params, // Copia los valores directamente
      };
    }

    // Llamada a la API
    const { data } = await getChecks(endpointParams);
    let fatigue = JSON.parse(data);

    const checks = fatigue.map((fatigue, index) => ({
      ...fatigue,
      id: `${index + 1}`,
    }));

    return dispatch(
      onGetChecksSuccess({
        checks,
      })
    );
  } catch (error) {
    return dispatch(
      onGetChecksError({
        error,
      })
    );
  }
};

export const GET_FRENTES = 'GET_FRENTES';
export const GET_FRENTES_ERROR = 'GET_FRENTES_ERROR';
export const GET_FRENTES_SUCCESS = 'GET_FRENTES_SUCCESS';
export const onGetFrentes = makeActionCreator(GET_FRENTES);
export const onGetFrentesError = makeActionCreator(GET_FRENTES_ERROR, 'payload');
export const onGetFrentesSuccess = makeActionCreator(
  GET_FRENTES_SUCCESS,
  'payload'
);

// Modificar el `onGetAsarcoThunk` para recibir el parámetro `shift`.
export const onGetFrentesThunk = (params = {}) => async dispatch => {
  dispatch(onGetFrentes());
  try {
    // Llamada a la API
    const { data } = await getFrentes();
    let frentess = JSON.parse(data);

    const frentes = frentess.map((item, index) => ({
      id: `frente-${index}`,   // Puedes usar un mejor id si lo tienes
      name: item.frente,
      status: item.fecha,
  }));

    return dispatch(
      onGetFrentesSuccess({
        frentes,
      })
    );
  } catch (error) {
    return dispatch(
      onGetFrentesError({
        error,
      })
    );
  }
};
